'use client';

import { tsrShared } from '@/libs/ts-rest/ts-rest';
import { createLanguageGetByIdQueryOptions } from '@/modules/shared/contracts';
import type { LanguageGetByIdQueryOptions } from '@/modules/shared/contracts';

export const useLanguageGetByIdQuery = (languageId?: string, options?: Partial<LanguageGetByIdQueryOptions>) => {
	const queryOptions = createLanguageGetByIdQueryOptions(languageId);

	return tsrShared.languages.getById.useQuery({
		...queryOptions,
		...options,
	});
};
